import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon-stt.svg'
import _imports_1 from '@/app/ui/assets/svg/dot-black.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_info_circle.svg'


const _hoisted_1 = { class: "relative bg-blue-lp-600 rounded-xl" }
const _hoisted_2 = { class: "relative bg-white border border-blue-lp-800 rounded-xl" }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center p-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "block w-6 h-6",
  alt: "icon-stt"
}, null, -1)
const _hoisted_5 = { class: "text-black-lp-200 text-sm font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", { class: "border-gray-lp-1400" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "bg-gray-lp-1400 w-full",
  style: {"height":"1px"}
}
const _hoisted_8 = { class: "flex flex-row justify-between items-center gap-1" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex flex-row items-center gap-1 text-black-lp-100 text-sm mt-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-1 h-1",
  alt: "icon-dot"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-1 h-1",
  alt: "icon-dot"
}, null, -1)
const _hoisted_13 = { class: "flex flex-row gap-1 items-center p-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "block w-6 h-6",
  alt: "icon-info"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("pusatResolusi.infobar.alreadyReported")), 1)
      ]),
      _hoisted_6,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "flex flex-col p-2 space-y-3",
          key: index.toString()
        }, [
          (index !== 0)
            ? (_openBlock(), _createBlock("div", _hoisted_7))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", {
                class: ["rounded-full px-3 py-1 text-white text-xs self-start", `${_ctx.mapBackgroundStyle(item)}`]
              }, _toDisplayString(_ctx.mapCaseTypeLabel(item.caseTypeLabel)), 3),
              _createVNode("div", _hoisted_10, [
                _createTextVNode(" #" + _toDisplayString(item.caseNumber) + " ", 1),
                _hoisted_11,
                _createVNode("span", null, _toDisplayString(item.categoryName), 1),
                _hoisted_12,
                _createVNode("span", null, _toDisplayString(_ctx.$t(`${item.statusLabel}`)), 1)
              ])
            ]),
            _createVNode("div", null, [
              _createVNode("button", {
                class: "bg-blue-lp-600 text-blue-lp-500 rounded-md px-3 py-2 text-xs font-semibold",
                onClick: ($event: any) => (_ctx.handleItemClick(item))
              }, _toDisplayString(_ctx.$t("pusatResolusi.infobar.seeDetail")), 9, ["onClick"])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode("p", {
        class: "text-black-lp-200 text-sm",
        innerHTML: _ctx.infoText
      }, null, 8, ["innerHTML"])
    ])
  ]))
}